import React from 'react';
import ReportsArtists from '../components/Reports/ReportsArtists';
import '../components/LiveIntel/liveIntel.css';
import '../components/Reports/reports.css';

const ReportsArtistsPage = () => <ReportsArtists />;

export default ReportsArtistsPage;
